<template>
  <div class="flex flex-col">
    <h1 class="text-black font-bold">Change Canvas Size</h1>

    <numberer v-model='size.cols' :step='1' />
    <numberer v-model='size.rows' :step='1' />

    <div class="justify-around flex flex-row flex-none mt-4">
      <pbc-button @click='onIncrease'>+ Bigger</pbc-button>
      <pbc-button @click='onDecrease'>+ Smaller</pbc-button>
    </div>

    <div class="justify-around flex flex-row flex-none mt-4">
      <button @click='onPortrait' class="px-2 rounded my-1 text-center flex flex-col items-center justify-center h-24"
            style='background-color: #4A5568'>
        <crop-portrait class="text-gray-400" :size='48' />
        <div class="post-type-button">
            <span>Portrait</span>
        </div>
      </button>
      <button @click='onLandscape' class="px-2 rounded my-1 text-center flex flex-col items-center justify-center h-24"
            style='background-color: #4A5568'>
        <crop-landscape class="text-gray-400" :size='48' />
        <div class="post-type-button">
            <span>Landscape</span>
        </div>
      </button>
      <button @click='onSquare' class="px-2 rounded my-1 text-center flex flex-col items-center justify-center h-24"
            style='background-color: #4A5568'>
        <crop-square class="text-gray-400" :size='48' />
        <div class="post-type-button">
            <span>Square</span>
        </div>
      </button>
    </div>


  </div>
</template>
<script>
import CropPortrait from '@icons/CropPortrait.vue';
import CropLandscape from '@icons/CropLandscape.vue';
import CropSquare from '@icons/CropSquare.vue';
export default {
  props:{
    size:{
      type:Object,
      required:true
    }
  },
  components:{
    CropPortrait,
    CropLandscape,
    CropSquare
  },
  methods:{
    onPortrait() {
      this.size.cols = 9;
      this.size.rows = 16;
    },
    onLandscape() {
      this.size.cols = 16;
      this.size.rows = 9;
    },
    onSquare() {
      this.size.cols = 12;
      this.size.rows = 12;
    },
    onIncrease() {
      this.size.cols += this.size.cols * 0.1;
      this.size.rows += this.size.rows * 0.1;
    },
    onDecrease() {
      this.size.cols -= this.size.cols * 0.1;
      this.size.rows -= this.size.cols * 0.1;
    }
  }
}
</script>
